export default "__VITE_ASSET__a97950bb__"